import { render, staticRenderFns } from "./TiposPagamento.vue?vue&type=template&id=d2fbe476&scoped=true&"
import script from "./TiposPagamento.vue?vue&type=script&lang=js&"
export * from "./TiposPagamento.vue?vue&type=script&lang=js&"
import style0 from "./TiposPagamento.vue?vue&type=style&index=0&id=d2fbe476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fbe476",
  null
  
)

export default component.exports